// extracted by mini-css-extract-plugin
module.exports = {"clampedNote":"ClampedNote_clampedNote__e6q4L","clamped":"ClampedNote_clamped__1EM53","expandToggle":"ClampedNote_expandToggle__qK4jP"};